export enum MailingListChannelTypesEnum {
	InAppNotification = 'in-app-notification',
	AppPopup = 'app-popup',
	Email = 'email',
	SMS = 'sms',
}
